import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { UploadSimple, Trash } from "@phosphor-icons/react";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

export default function MyPhotos() {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(0);
  const ref = useRef();
  const load = () => api.get("/photos").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  const upload = async (files) => {
    const list = [...files]; setBusy(list.length);
    for (const f of list) {
      const fd = new FormData(); fd.append("file", f);
      try { await api.post("/photos/upload", fd); } catch (e) { toast.error(`${f.name}: ${e.response?.data?.detail || "errore"}`); }
      setBusy((n) => n - 1);
    }
    load(); ref.current.value = "";
  };
  const del = async (id) => {
    if (!window.confirm("Eliminare questa foto?")) return;
    try { await api.delete(`/photos/${id}`); load(); } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  if (!items) return null;
  return (
    <div className="space-y-6" data-testid="my-photos">
      <div className="max-w-3xl text-sm text-stone space-y-1">
        <p>Carica le foto vere della tua struttura: camere, colazione, esterni, dettagli. Otelya le usa al posto delle foto generiche nei post di Facebook e Instagram, negli articoli del blog e nei video TikTok.</p>
        <p>Se non carichi nulla, Otelya continua a scegliere da solo foto adatte. Consiglio: almeno 10 foto, luminose, in verticale per TikTok e storie.</p>
      </div>
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/heic" multiple hidden onChange={(e) => upload(e.target.files)} data-testid="photos-input" />
      <Button className="rounded-full bg-ink text-canvas" disabled={busy > 0} onClick={() => ref.current.click()} data-testid="photos-upload-btn">
        <UploadSimple size={16} className="mr-1" />{busy ? `Carico… (${busy} rimaste)` : "Carica foto"}
      </Button>
      <div className="text-xs text-stone" data-testid="photos-count">{items.length} / 100 foto</div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3">
        {items.map((p) => (
          <div key={p.id} className="relative group rounded-xl overflow-hidden aspect-square bg-sand" data-testid={`photo-${p.id}`}>
            <img src={`${API}${p.url}`} alt={p.original_filename} className="w-full h-full object-cover" loading="lazy" />
            <button onClick={() => del(p.id)} className="absolute top-2 right-2 p-1.5 rounded-full bg-ink/70 text-canvas opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity" data-testid={`photo-delete-${p.id}`}><Trash size={14} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
